
import {
    defineComponent,
    onMounted,
    reactive,
    ref,
    getCurrentInstance,
} from 'vue'
import { accountTypeOptions, statusOptions } from './config'
import { useTableScroll } from '@/common/mixins/useTableScroll'
import { getList } from './request'
import { UsePageDto } from '@/common/mixins/listPageDto'
import { useStore } from 'vuex'
import formatDate from '@/common/functions/formatDate'
import { message, Modal } from 'ant-design-vue'
import Add from './components/Add.vue'
import handleStartTime from 'library/functions/handleStartTime'
import handleEndTime from 'library/functions/handleEndTime'

export default defineComponent({
    components: {
        Add,
    },
    setup() {
        let filter = reactive({
            type: null,
            status: null,
            corpName: '',
            timeRange: null,
        })
        let data = ref([])
        let loading = ref(false)
        const store = useStore()
        const instance = getCurrentInstance()
        const { scroll } = useTableScroll(instance)

        const {
            pagination,
            listPageDto,
            handleTableChange,
            refresh,
        } = UsePageDto(instance)
        const columns = [
            {
                title: '申请时间',
                dataIndex: 'createTime',
                slots: { customRender: 'createTime' },
                key: 'createTime',
                width: 170,
            },
            {
                title: '申请手机号',
                dataIndex: 'mobile',
                key: 'mobile',
                width: 170,
            },
            {
                title: '企业名称',
                dataIndex: 'corpName',
                key: 'corpName',
                width: 180,
            },
            {
                title: ' 申请人',
                dataIndex: 'applyName',
                key: 'applyName',
                width: 120,
            },
            {
                title: '申请会话数',
                dataIndex: 'applyCount',
                key: 'applyCount',
                width: 170,
            },
            {
                title: '成交金额',
                dataIndex: 'dealAmount',
                key: 'dealAmount',
                width: 140,
            },

            {
                title: '当前状态',
                dataIndex: 'statusDesc',
                key: 'statusDesc',
                width: 140,
            },
            {
                title: '附件',
                dataIndex: 'attachments',
                slots: { customRender: 'attachments' },
                key: 'attachments',
                width: 200,
            },
            {
                title: '更新时间',
                dataIndex: 'updateTime',
                slots: { customRender: 'updateTime' },
                key: 'updateTime',
                width: 170,
            },
            {
                title: '备注说明',
                dataIndex: 'remark',
                key: 'remark',
                width: 200,
            },
            {
                dataIndex: 'action',
                title: '操作',
                fixed: 'right',
                slots: { customRender: 'action' },
                width: 100,
            },
        ]
        // 获取列表
        const fetchList = async () => {
            const params = {
                corpName: filter.corpName || null,
                type: filter.type || null,
                status: filter.status || null,
                pageDto: {
                    pageNum: listPageDto.pageNum,
                    pageSize: listPageDto.pageSize,
                },
            }
            let timeRange: any = filter.timeRange
            if (timeRange) {
                Object.assign(params, {
                    startTime: handleStartTime(new Date(timeRange[0])),
                    endTime: handleEndTime(new Date(timeRange[1])),
                })
            }
            loading.value = true
            try {
                const res = await getList(params)
                loading.value = false
                data.value = res.data
                Object.assign(listPageDto, res.pageDto)
            } catch (e) {
                loading.value = false
            }
        }

        function modAction(record: any) {
            store.commit('toggleMsgauditApplyAddState', true)
            store.commit('setMsgauditApplyDetail', record)
        }

        function addAction() {
            store.commit('toggleMsgauditApplyAddState', true)
        }

        onMounted(() => {
            fetchList()
        })
        return {
            data,
            columns,
            store,
            scroll,
            formatDate,
            loading,
            filter,
            fetchList,
            modAction,
            pagination,
            refresh,
            statusOptions,
            addAction,
            accountTypeOptions,
            handleTableChange,
        }
    },
})
